import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const CompaniesCtaSection = () => (
    <section id="cta" className="lp-cta">
        <div className="lp-cta-card" data-lp-reveal>
            <div className="lp-cta-glow" aria-hidden="true" />
            <div className="lp-cta-inner">
                <h2>Become the best-prepared company in the room.</h2>
                <p className="sub">Start free — no credit card required. Takes 2 minutes.</p>
                <div className="lp-cta-btns">
                    <Link className="lp-cta-btn" to={ROUTES.REGISTER}>Start free</Link>
                    <a className="lp-cta-btn lp-cta-btn--outline" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                </div>
            </div>
        </div>
    </section>
);

export default CompaniesCtaSection;
